import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=30232866&"
import script from "./HomeCover.vue?vue&type=script&lang=js&"
export * from "./HomeCover.vue?vue&type=script&lang=js&"
import style0 from "./HomeCover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports